<template>
  <BbBtn size="large" type="secondary" :class="{ selected: isSelected }" @click="selectValue"
    >{{ tacticContext.name }}
  </BbBtn>
</template>

<script>
export default {
  props: {
    tacticContext: {
      type: Object,
      default: () => {},
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const selectValue = () => emit('set-filter-value', props.tacticContext.id);
    return {
      selectValue,
    };
  },
};
</script>

<style scoped lang="scss">
.selected {
  border: 4px solid #6222e3 !important;
  background: $bb-interface-11 !important;

  :deep(.v-btn__content) {
    color: #6222e3;
  }

  &:hover {
    border: 4px solid #6222e3 !important;
    background: $bb-interface-11 !important;
  }
}

button {
  border-radius: 4px !important;
  border: 1px solid $bb-neutral-3 !important;
  padding: 16px 24px !important;
  display: flex;
  align-items: center;
  height: 54px !important;

  &:hover {
    border: 1px solid $bb-neutral-1 !important;
    background: transparent !important;
  }

  :deep(.v-btn__content) {
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
  }
}
</style>
